import {Operation} from "./Operation.js";


export class Mean extends Operation {

    static displayName() {
        return "Mean";
    }

    static isNumeric() {
        return true;
    }

    static isCategorical() {
        return false;
    }

    static handlesDate() {
        return false;
    }

    incrementAggregation(newValue) {
        if (this.currValue === null) {
            this.currValue = {count: 0, sum: 0};
        }
        this.currValue.count += 1;
        this.currValue.sum += (newValue || 0)
    }

    finish(globalAggregation) {
        return (this.currValue.sum / this.currValue.count);
    }

}


export default Mean;